// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"62185b2d","186":"24c0e291","344":"8f841a62","372":"e603ab46","377":"539040bf","630":"fe5d3000","841":"b48ef922","849":"9ca54dbe","856":"4179b818","858":"2f11d91f"}[chunkId] + ".chunk.js";
};